module.exports = __webpack_public_path__ + "cd455783/img/settings-ico.a214628d.svg";